import React from "react";
import myLogo from "./images/JCLogo3.svg";
import mauLogo from "./images/mau-logo.svg";
import fiuLogo from "./images/fiu-logo.svg";
import uruLogo from "./images/uru-logo.svg";
import fatensorflow from "./images/fa-tensorflow.svg";
import fad3 from "./images/D3.svg";
import rocCurve from "./images/ROC Curve.png";
import filteredData from "./images/filtered data.png";
import nuCropMain from "./images/nuCrop main.JPG";
import nuCropBrowse from "./images/nuCrop browse.JPG";
import nuCropValidate from "./images/nuCrop validate.JPG";
import nuCropResult from "./images/nuCrop result.JPG";
import classificationResults from "./images/classification results.png";
import "@fortawesome/fontawesome-free/js/all.js";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

require("bootstrap");

const aboutText =
  "I'm a MS in Electrical Engineering and MBA holder passionate about software development, \
  data science, computer vision and business analysis. I designed this website using \
  node.js, react, bootstrap, css-flexbox, and uploaded it using git. Here you will \
  find the projects I've made in different programming languages as well as the \
  technologies I used for each of them.";

const projectsText =
  "Scroll down to see the projects I've developed since starting my Masters in \
  Electrical Engineering program at Florida International University. Since then, \
  I have learned many technologies and programming languages! Click on the icons \
  below to learn more about some of the tools I've used for my projects";

const eegTextTitle =
  "Interictal Spikes Detection - Implementing Neural Networks";

const eegTextFirst =
  "Epilepsy is an illness that affects a sizeable percentage of the people worldwide, \
  being one of the most common neurological diseases globally. The brain’s electrical \
  activity can be measured using Electroencephalogram (EEG) data, which neurologists \
  can study in order to find the source of epileptic seizures in the human brain. This \
  process can consume a lot of a neurologist’s valuable time, since they have to \
  manually analyze hours of EEG data. The purpose of this project is to find an \
  automated method to detect interictal spikes in EEG data, in order to simplify the \
  neurologist’s job by saving time, which will in consequence reduce costs associated \
  to EEG testing.";

const eegTextSecond = "";

const nuCropTitle = "NuCrop - Image Processing Application";

const nuCropText =
  "This is a program I developed for Entopsis, LLC. They needed a program that could \
  detect, crop, and automatically save each of the rectangular slides shown in the \
  pictures. This was the first time I had to develop a GUI, for which I used the TKinter \
  library. The program works by converting the RGB image to grayscale, and then finds \
  the position of each slide by calculating the mean of certain areas in the image. It \
  scans the image both horizontally and vertically to do this. Using this data, the image \
  is finally cropped and saved individually in the folder of the original image.";

function App() {
  return (
    <div className="app">
      <header>
        <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
          <a className="navbar-brand" href="#intro-section">
            <img src={myLogo} alt="myLogo" className="app-mylogo" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto nav-fill w-100">
              <li className="nav-item">
                <a href="#about-section" className="nav-link">
                  About Me
                </a>
              </li>
              <li className="nav-item">
                <a href="#projects-section" className="nav-link">
                  Projects
                </a>
              </li>
              <li className="nav-item">
                <a href="#education-section" className="nav-link">
                  Education
                </a>
              </li>
              <li className="nav-item">
                <a href="#contact-section" className="nav-link">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </header>

      <div className="sections">
        <section id="intro-section" className="intro-section bg-white">
          <div>
            <div>
              <h4>{"Welcome to my Portfolio Website"}</h4>
            </div>
            <div>
              <h4>{"I am"}</h4>
            </div>
            <div>
              <div>
                <h1>{"Jose"}</h1>
              </div>
              <div>
                <h1>{"Cedeno"}</h1>
              </div>
            </div>
          </div>
        </section>
        <section id="about-section" className="bg-light">
          <div>
            <p className="section-text">{aboutText}</p>
          </div>
        </section>
        <section id="projects-section" className="bg-white">
          <div>
            <p className="section-text">{projectsText}</p>
            <div className="container-fluid skills-array">
              <div className="row">
                <div className="col-lg-4">
                  <a
                    href="https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-3x fa-html5"></i>
                  </a>
                </div>
                <div className="col-lg-4">
                  <a
                    href="https://developer.mozilla.org/en-US/docs/Web/CSS"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-3x fa-css3-alt"></i>
                  </a>
                </div>
                <div className="col-lg-4">
                  <a
                    href="https://www.javascript.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-3x fa-js-square"></i>
                  </a>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <a
                    href="https://getbootstrap.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-3x fa-bootstrap"></i>
                  </a>
                </div>
                <div className="col-lg-4">
                  <a
                    href="https://sass-lang.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-3x fa-sass"></i>
                  </a>
                </div>
                <div className="col-lg-4">
                  <a
                    href="https://reactjs.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-3x fa-react"></i>
                  </a>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <a
                    href="https://d3js.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img className="fa-d3" src={fad3} alt="Python-Logo" />
                  </a>
                </div>
                <div className="col-lg-4">
                  <a
                    href="https://nodejs.org/en/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-3x fa-node-js"></i>
                  </a>
                </div>
                <div className="col-lg-4">
                  <a
                    href="https://www.npmjs.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-3x fa-npm"></i>
                  </a>
                </div>
              </div>
              <div className="row tf-div">
                <div className="col-lg-6">
                  <a
                    href="https://www.python.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-3x fa-python" />
                  </a>
                </div>
                <div className="col-lg-6">
                  <a
                    href="https://www.tensorflow.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="fa-tensorflow"
                      src={fatensorflow}
                      alt="tensorflow-logo"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="eeg-project" className="bg-light">
          <div>
            <h3>{eegTextTitle}</h3>
            <p className="section-text">{eegTextFirst}</p>
            <p className="section-text">{eegTextSecond}</p>
            <a
              href="https://github.com/jdcedeno/interictal-spikes"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fas fab fa-github fa-2x"></i>
            </a>
            <p>{"View on Github"}</p>
            <div className="img-flex">
              <div>
                <img src={rocCurve} alt="ROC Curve" />
              </div>
              <div>
                <img src={filteredData} alt="Filtered Data" />
              </div>
              <div>
                <img src={classificationResults} alt="Classification Results" />
              </div>
            </div>
          </div>
        </section>
        <section id="nuCrop-project" className="bg-white">
          <div>
            <h3>{nuCropTitle}</h3>
            <p className="section-text">{nuCropText}</p>
            <a
              href="https://github.com/jdcedeno/nuCrop"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-github fa-2x"></i>
            </a>
            <p>{"View on Github"}</p>
            <div className="img-flex">
              <div>
                <img src={nuCropMain} alt="nuCrop main" />
              </div>
              <div>
                <img src={nuCropBrowse} alt="nuCrop browse" />
              </div>
              <div>
                <img src={nuCropValidate} alt="nuCrop validate" />
              </div>
              <div>
                <img src={nuCropResult} alt="nuCrop result" />
              </div>
            </div>
          </div>
        </section>

        <section id="education-section" className="container-fluid bg-light">
          <div className="row w-100 education-row">
            <div className="col-lg-4">
              <a
                href="https://www.maufl.edu/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={mauLogo}
                  alt="university logo"
                  className="university-logo"
                />
              </a>
            </div>
            <div className="col-lg-4">
              <div className="row">
                <h3 className="mx-auto">
                  {"Master of Business Administration"}
                </h3>
              </div>
              <div className="row">
                <h5 className="mx-auto">{"Millennia Atlantic University"}</h5>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="grad-date">
                <div className="row">
                  <h6 className="mx-auto">{"May, 2020"}</h6>
                </div>
                <div className="row">
                  <h6 className="mx-auto">{"Miami, FL"}</h6>
                </div>
              </div>
            </div>
          </div>
          <div className="row w-100 education-row">
            <div className="col-lg-4">
              <a
                href="https://www.fiu.edu/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={fiuLogo}
                  alt="university logo"
                  className="university-logo"
                />
              </a>
            </div>
            <div className="col-lg-4">
              <div className="row">
                <h3 className="mx-auto">
                  {"Master of Science in Electrical Engineering"}
                </h3>
              </div>
              <div className="row">
                <h5 className="mx-auto">
                  {"Florida International University"}
                </h5>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="grad-date">
                <div className="row">
                  <h6 className="mx-auto">{"Dec, 2017"}</h6>
                </div>
                <div className="row">
                  <h6 className="mx-auto">{"Miami, FL"}</h6>
                </div>
              </div>
            </div>
          </div>
          <div className="row w-100 education-row">
            <div className="col-lg-4">
              <img
                src={uruLogo}
                alt="university logo"
                className="university-logo"
              />
            </div>
            <div className="col-lg-4">
              <div className="row">
                <h3 className="mx-auto">
                  {"Bachelor of Electrical Engineering"}
                </h3>
              </div>
              <div className="row">
                <h5 className="mx-auto">{"Universidad Rafael Urdaneta"}</h5>
              </div>
            </div>
            <div className="col-lg-4 education-col">
              <div className="grad-date">
                <div className="row">
                  <h6 className="mx-auto">{"Dec, 2014"}</h6>
                </div>
                <div className="row">
                  <h6 className="mx-auto">{"Maracaibo, Venezuela"}</h6>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="contact-section" className="bg-dark">
          <div className="contact-email">
            <span className="text-white">
              <i className="far fa-envelope"></i>
              <p className="text-white">{"josedcedeno@gmail.com"}</p>
            </span>
          </div>

          <a
            className="text-white"
            href="https://www.linkedin.com/in/josedcedeno/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin-in"></i>
          </a>
        </section>
      </div>
    </div>
  );
}

export default App;
